import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../../../../../../services/auth.service';
import { AffectationService } from '../../../../../../../services/affectation.service';
import { FlagService } from '../../../../../../../shared/services/flag.service';
import { FlagType } from '../../../../../../../shared/utils/enums';
import { AddressService } from '../../../../../../../services/address.service';
import { AdresseDto } from '../../../../../../../models/Establishment';
import { debounceTime } from 'rxjs';
import { EstablishmentService } from '../../../../../../../services/establishment.service';

@Component({
  selector: 'app-add-services-affectation',
  templateUrl: './add-services-affectation.component.html',
  styleUrl: './add-services-affectation.component.scss',
})
export class AddServicesAffectationComponent implements OnInit {
  loading = false;
  loadingAff = false;
  apiFilter = false;
  header = 'Ajouter un service d’affectation';
  responseMessage = 'Service d’affectation ajouté avec succès !';
  file: any[] = [];
  loadingAddress = false;
  form = this.fb.group({
    id: [''],
    serviceType: [<string | null>null, Validators.required],
    siteId: ['', Validators.required],
    name: [''],
    serviceDescription: ['', Validators.maxLength(500)],
    isvisible: [true],
    numberOfBedsOrRooms: [''],
    numberOfPatientsCaredForPerYear: [''],
    numberOfStaffWorkingInService: [''],
    email:['',Validators.email],
    firstServicePhoto: [<string | null>null],
    secondServicePhoto: [<string | null>null],
    thirdServicePhoto: [<string | null>null],
    etablissement_id: this.auth.id,
    fichePostes: [[{}]],
  });
  affectationImages: string[] = [];
  affectationList: any[] = [];
  affectationFilterList: any[] = [];
  addressList: AdresseDto[] = [];
  fichePosteFiles: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddServicesAffectationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthService,
    private flag: FlagService,
    private addressService: AddressService,
    private establishmentService: EstablishmentService,
    private affectationService: AffectationService
  ) {}

  ngOnInit() {
    this.getAffectationServices();
    this.getAddresses();

    if (this.data.isModify) {
      this.header = "Modifier le service d’affectation";
      this.responseMessage = "Service d’affectation modifié avec succès !";
      this.fichePosteFiles = this.data.affectationData.fichePostes?.map(
        (el: any) => {
          let file = new File(
            ['data:application/pdf;base64,' + el.pdfContent],
            el.name + '.pdf',
            {
              type: 'application/pdf',
            }
          );
          return {
            id: el.id,
            file,
            url: 'data:application/pdf;base64,' + el.pdfContent,
          };
        }
      );
      this.form.patchValue(this.data.affectationData);
        this.affectationImages.push(
          this.data.affectationData.firstServicePhoto
        );
        this.affectationImages.push(
          this.data.affectationData.secondServicePhoto
        );
        this.affectationImages.push(
          this.data.affectationData.thirdServicePhoto
        );

    }
  }

  getAddresses() {
    this.loadingAddress = true;
    this.establishmentService
      .getSiteByEstablishmentId(this.auth.id!, true)
      .subscribe({
        next: (value) => {
          this.loadingAddress = false;
          this.addressList = value;
        },
      });
  }

  getAffectationServices() {
    this.loadingAff = true;
    this.affectationService.getAllAffectation().subscribe({
      next: (res) => {
        this.loadingAff = false;
        this.affectationList = res.map((res: any) => {
          return {
            label: res.name,
            value: res.id,
          };
        });
        this.affectationFilterList = this.affectationList;
        if (this.data.isModify) {
          // this.form.get('serviceType')?.patchValue('test')
        }
      },
    });
  }

  close(ev: boolean) {
    this.dialogRef.close(ev);
  }
  addAffectationServices() {
    this.loading = true;
    const body = this.form.value;
    if (!body.name) {
      body.name = body.serviceType;
    }
    this.affectationService.addAffectationService(body).subscribe({
      next: () => {
        this.flag.displayFlag(
          this.responseMessage,
          FlagType.success
        );
        this.close(true);
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
        const msg = err?.error?.message?.includes("ConstraintViolationException") ? "Fiche de poste est liée à une mission ne peut pas être supprimée." : 'Une erreur est survenue !'
        this.flag.displayFlag(msg, FlagType.error);
      },
    });
  }
  getImage(images: string[]) {
    this.affectationImages = images;
    this.form.get('firstServicePhoto')?.patchValue(null);
    this.form.get('secondServicePhoto')?.patchValue(null);
    this.form.get('thirdServicePhoto')?.patchValue(null);
    if (images[0]) {
      this.form.get('firstServicePhoto')?.patchValue(images[0]);
    }
    if (images[1]) {
      this.form.get('secondServicePhoto')?.patchValue(images[1]);
    }

    if (images[2]) {
      this.form.get('thirdServicePhoto')?.patchValue(images[2]);
    }
  }

  getFile(files: any, label: string) {
    let body: any[] = [];
    let pdfContent = '';
    files?.map((el: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(el.file); // read file as data url
      reader.onload = (event) => {
        // called once readAsDataURL is completed
        // @ts-ignore
        pdfContent = event.target?.result;
        body = [
          ...body,
          {
            id: el.id,
            name: el.file.name,
            pdfContent: pdfContent.split('base64,')[1],
          },
        ];
        this.form.get('fichePostes')?.patchValue(body);
      };
    });
    // if (files) {
    //   this.file = [...this.file, , { label, ...files }];
    // }
    this.file = this.file?.filter((el) => el.file);
    // let paylaod = this.file.map((el, key) => {
    //   return {
    //     name: el[key].name,
    //     pdfContent: '',
    //   };
    //   // this.form.get('fichePostes')?.patchValue();
    //   // this.documentFormGroup.patchValue({ [el.label]: el[0] });
    // });
    // Object.keys(this.documentFormGroup.controls).map((el) => {});
  }
  deleteFile(index: number, label: string) {
    let currentDocs =  this.form.get('fichePostes')?.value || []
    // this.file = this.file.filter((el) => el.label != label);
    currentDocs.splice(index, 1)
    this.form.get('fichePostes')?.patchValue(currentDocs)
    // this.documentFormGroup.get(`${label}`)?.patchValue('');
  }
  autoCompleteOnChange(ev: any) {
    this.affectationFilterList = this.affectationList.filter((a) =>
      a.label.toLowerCase().includes(ev.value.toLowerCase())
    );
  }
}
